import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { MenuItem } from "primeng/api";
import { IEpisode } from "@project/models/episodes/episode";
import { DocumentsRequestedRibbonService } from "@project/document-upload-request/ribbon/ribbon.service";
import { DocumentUploaderService } from "@project/document-upload-request/document-uploader.service";

@Component({
    selector: "episode-header-v2",
    templateUrl: "./episode-header.component.html",
    styleUrls: ["./episode-header.component.scss"],
    providers: [DocumentsRequestedRibbonService, DocumentUploaderService]
})
export class EpisodeHeaderComponent {
    showEpisodeHeaderDialog = false;

    @HostBinding("class") hostClass = "episode-header";

    @Input() episode: IEpisode;
    @Input() showPlusButton: boolean = true;
    @Input() showEllipsisButton: boolean = true;
    @Input() showActionButtons: boolean = true;
    @Input() showBanButton: boolean = true;
    @Input() episodeOptionsButtonPlusItems: MenuItem[];
    @Input() episodeOptionsButtonEllipsisItems: MenuItem[];
    @Input() episodeOptionsButtonBanItems: MenuItem[];
    @Input() expandHeaderSmScreen = true;
    @Input() showViewButton = false;
    @Input() showHower = false;

    @Output() readonly refreshEpisodes = new EventEmitter<void>();    
    @Output() readonly viewEpisode = new EventEmitter<string>();
}
